// extracted by mini-css-extract-plugin
export default {"blog":"styles_blog__4tDvL","blog__link":"styles_blog__link__zWUT+","item":"styles_item__iSjLD","item__in":"styles_item__in__wuZr6"};